module.exports = __webpack_public_path__ + "static/img/security.1130a5b7.png";